
let config = {
    development: {
        apiHost: 'http://localhost:3000',
        assetsHost: "https://virtap.s3.amazonaws.com/test",
        loginPage: "http://localhost:8000/contratar-assistente-virtual/login.html",
        signupPage: "http://localhost:8000/contratar-assistente-virtual/cadastrar.html",
        profilePage: "http://localhost:8000/contratar-assistente-virtual/perfil.html"
    },
    production: {
        apiHost: 'https://apinew.virtap.com.br',
        assetsHost: "https://virtap.s3.amazonaws.com/production",
        loginPage: "https://new.virtap.com.br/contratar-assistente-virtual/login",
        signupPage: "https://new.virtap.com.br/contratar-assistente-virtual/cadastrar",
        profilePage: "https://new.virtap.com.br/contratar-assistente-virtual/perfil"
    }
}

export default config[process.env.NODE_ENV];